import { apiFunctionsEnum } from 'constants/api.constants';
import ApiService from './api.service';
import {
	setSettings,
	setLoading,
	setError,
	setSuccessfullyUpdated,
	updateSingleSetting,
} from 'state/reducers/system-settings.reducer';
import { setSuccessMessage } from 'state/reducers/ui.reducers';
import { setErrorMessage } from 'utils/index';

const apiService = ApiService.getInstance();

export const getAllSystemSettings = () => {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError({ exist: false }));
		try {
			const response = await apiService.execute(apiFunctionsEnum.GET_ALL_SYSTEM_SETTINGS);
			const settings = response.data.systemSettings;
			dispatch(setSettings(settings));

			return settings;
		} catch (error: any) {
			setErrorMessage(setError, {
				errorNumber: error?.response?.data?.error_number,
				statusCode: error?.response?.status,
			});
		} finally {
			dispatch(setLoading(false));
		}
	};
};

export const updateSystemSetting = (domain: string, key: string, value: string, description: string) => {
	return async (dispatch: any) => {
		dispatch(setSuccessfullyUpdated(false));
		dispatch(setLoading(true));
		try {
			const response = await apiService.execute(apiFunctionsEnum.UPDATE_SYSTEM_SETTING, {
				domain,
				key,
				value,
				description,
			});

			// Update the single setting in the state
			dispatch(updateSingleSetting({ domain, key, value, description }));
			dispatch(setSuccessfullyUpdated(true));
			dispatch(setSuccessMessage(true));

			return response.data;
		} catch (error: any) {
			setErrorMessage(setError, {
				errorNumber: error?.response?.data?.error_number,
				statusCode: error?.response?.status,
			});
			dispatch(setSuccessfullyUpdated(false));
		} finally {
			dispatch(setLoading(false));
		}
	};
};
